import React from 'react';
import { Brain, Camera, ArrowLeftRight, Search, GitMerge, Plug } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { features } from '@/data/features';
import { useScrollReveal } from '@/lib/useScrollReveal';

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Brain,
  Camera,
  ArrowLeftRight,
  Search,
  GitMerge,
  Plug,
};

export const FeatureGrid: React.FC = () => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section className="py-20 bg-white" ref={ref}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center mb-16 transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-4">
            Everything Your Agents Need
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
            Purpose-built infrastructure for agent memory management
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Brain;
            return (
              <Card
                key={feature.title}
                variant="interactive"
                className={`transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: `${(index + 1) * 80}ms` } as React.CSSProperties}
              >
                <div className="flex flex-col h-full">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-text-primary mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed flex-grow">
                    {feature.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;